export const ROUTES = {
  HOME: '/',
  LANDING: '/landing',
  ORGANIZATION: '/org',
  ORGANIZATION_CREATE: '/org/new',
  ORGANIZATION_EDIT: '/org/edit/:id',
  EVENT_NEW: '/events/new',
  EVENT_EDIT: '/events/edit/:id',
  USER_PROFILE: '/profile',
  PERSONAL_INFO: '/profile/personal-info',
  SAVED_EVENTS: '/profile/saved-events',
  INTERESTED_EVENTS: '/profile/interested-events',
  CALENDAR: '/calendar',
  SWIPE_EVENTS: '/swipe-events',
  STAFF_PROFILE: '/profile/staff',
  STAFF_REQUESTS: '/events/:id/staff',
  STAFF_VIEW: '/staff/:id',
  PROFILE_CHOICE: '/profile-choice',
  SIGNUP: '/signup',
  LOGIN: '/login',
  ADMIN: '/admin',
} as const;
